<template>
  <div class="news-categories">
    <div class="block-heading">
      {{category.name}}
    </div>
    <ul class="cat-list">
      <li :class="'' == getCurrent ? 'active' : '' " >
        <a @click="onChangeFilter('')" href="#">All</a>
      </li>
      <li :class="cat.slug == getCurrent ? 'active' : '' " v-for="(cat, counter) in categories" :key="counter">
        <a @click="onChangeFilter(cat.slug)" href="#"><span v-html="cat.name"></span> (<span>{{cat.count}}</span>)</a>
      </li>
    </ul>
  </div>
</template>

<script>

  import axios from 'axios'

  export default {
    name: "ArticleFilter",
    data() {
      return {
        categories: [],
        category: {slug: 'therapeutic_area', name: 'Categories', filters: []},
      }
    },

    computed: {
      getCurrent() { return this.$store.state.category; }
    },

    methods : {
      getCategories : function () {
        axios.get('/wp-json/wp/v2/posts/category/', {
          params: {
            taxonomy: this.category.slug,
          }
        }).then((response) => {
          var data = response.data;
          this.categories = data.filter(function(value) { return value.count > 0 });
        }, (error) => {
          console.log(error)
        })
      },

      onChangeFilter : function(value) {
        this.$store.commit('SET_LOADER', true);

        this.$router.push({query: {category: value}});

        this.$store.commit('SET_FILTER',value);
        this.$store.commit('SET_CURR_PAGE', 1);
        this.$store.dispatch('getPosts');
      },

    },
    mounted(){
      this.getCategories();
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/article/ArticleFilter.vue